export default class ShowMore {
  constructor(button) {
    this.dom = {
      button,
      targets: document.querySelectorAll(button.dataset.target),
      moreLabel: button.querySelector('.js-show-more-label'),
      lessLabel: button.querySelector('.js-show-less-label'),
    };

    this.expanded = false;

    this.dom.button.addEventListener('click', () => this.toggle());
  }

  toggle() {
    this.expanded = !this.expanded;

    this.dom.targets.forEach((target) => target.classList.toggle('d-none', !this.expanded));

    // Float the button while expanded so a long list can always be collapsed.
    this.dom.button.classList.toggle('is-floating', this.expanded);

    if (this.dom.moreLabel && this.dom.lessLabel) {
      this.dom.moreLabel.classList.toggle('d-none', this.expanded);
      this.dom.lessLabel.classList.toggle('d-none', !this.expanded);
    }

    // Collapsing removes the floating button and shrinks the list, which can
    // leave the viewport far below; bring the button back into view.
    if (!this.expanded) {
      this.dom.button.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }
}
